// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"0cf13af4","171":"35a4e24f","268":"d4a7519a","366":"44633961","735":"e8d91259","866":"47a4845d","974":"fd26f138"}[chunkId] + ".chunk.js";
};